var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLike = function SvgLike(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Like_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.195 4.578-2.25 2.224L12 7.844l2.249-2.223a3.983 3.983 0 0 1 2.8-1.146c1.05 0 2.057.412 2.8 1.146a3.891 3.891 0 0 1 1.16 2.768 3.891 3.891 0 0 1-1.16 2.768L12 18.915l-7.848-7.758a3.892 3.892 0 0 1-1.16-2.768c0-1.038.417-2.033 1.16-2.768a3.983 3.983 0 0 1 2.8-1.146c1.05 0 2.057.412 2.8 1.146l.24.238 1.055-1.042-.242-.238A5.483 5.483 0 0 0 6.952 3 5.483 5.483 0 0 0 3.097 4.58 5.357 5.357 0 0 0 1.5 8.389c0 1.429.574 2.8 1.597 3.81L12 21l8.903-8.801a5.357 5.357 0 0 0 1.597-3.81c0-1.43-.574-2.8-1.596-3.81A5.483 5.483 0 0 0 17.05 3a5.483 5.483 0 0 0-3.855 1.578Z",
    fill: "#344054"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Like_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(1.5 3)",
    d: "M0 0h21v18H0z"
  })))));
};
export default SvgLike;